const data = [
  { title: 'CA. Dharmendra Kumar Chachan', pic: './public/images/r5.png', items: [
    'He has a qualified Diploma in Information System Audit. He has a very diversified audit \
     experience and has held various responsibilities for internal audit, legal, controls & \
     regulatory compliance and risk management. He looks after the Audit and Advisory practice of the firm. ',
  ]},

  { title: 'CA. Naresh Kumar Lath', pic: './public/images/c1n.png', items: [
    'He is a commerce graduate and fellow member of the Institute of Chartered \
     Accountant of India(ICAI). He also has a qualified Diploma in Information System \
     Audit.His proven expertise lies in direct and indirect taxation.He looks after the bank \
     audits and tax practice of the firm.'
  ]},
];
export default data;



// WEBPACK FOOTER //
// ./src/OurTeamPage/data.js